import { xor } from 'lodash'
import { actionTypes } from '../actions/data'
import i18n from '../i18n'
import { initParams } from './params'

//DEFAULT STATE
export const initData = {
  filteredFunds: [],
  allFunds: [],
  productTypeOptions: [],
  mgtStyleOptions: [] /* Used on load*/,
  tier1CatOptions: [],
  tier2CatOptions: [],
  tier3CatOptions: [],
  leverageOptions: [],
  currenciesOptions: [],
  countryExpOptions: [],
  mstarOptions: [],
  aumOptions: [],
  yieldOptions: [],
  volumeOptions: [],
  expenseOptions: [],
  inceptionOptions: [],
  productRegionOptions: [],
  esgOptions: [],
  sortDirection: 'DESC',
  sortColumn: 'AUM',
  selectedProductTypeOptions: [],
  selectedMgtStyleOptions: [],
  selectedTier1Options: [],
  selectedTier2Options: [],
  selectedTier3Options: [],
  selectedCountryExpOptions: [],
  selectedProductRegionOptions: [],
  selectedStructureOptions: [],
  selectedEsgOptions: [],
  selectedInceptionOptions: [],
  selectedAumOptions: [],
  selectedYieldOptions: [],
  selectedMstarOptions: [],
  selectedExpenseOptions: [],
  selectedVolumeOptions: [],
  selectedCurrenciesOptions: [],
  selectedLeverageOptions: [],
  selectedUseOfIncomeOptions: [],
  toggleDocument: true,
  showDocumentList: [],
  Icon: 'angle-double-down',
  searchBoxText: '',
  oldTicker: '',
  asOfDate: '',
  initialLoad: false,
  activePane: 'fund'
}

function month2digits(month) {
  return (month < 10 ? '0' : '') + month
}

// WRITES
const data = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DATA:
      // create array of countries delimites by commas
      const asOfDate = action.value[0].NAV_Date
      const wtDivisionID = action.value[0].wtDivisionID
      action.value.map(function (obj) {
        if (obj.CountryExp != null) {
          const x = obj.CountryExp.toString().split('|')
          obj.exposures = x
          return obj
        }
        return null
      })
      //esg
      action.value.map(function (obj) {
        if (obj.esgTagArray != null) {
          const x = obj.esgTagArray.toString().split(',')
          obj.esgTag = x
          return obj
        }
        return null
      })

      action.value.map(function (obj) {
        if (obj.inception_DateTime != null) {
          let d = new Date()
          let yyyy = d.getUTCFullYear()
          let mm = month2digits(d.getUTCMonth() + 1)
          let dd = month2digits(d.getUTCDate())

          let today = yyyy + '-' + mm + '-' + dd
          let inceptD = obj.inception_DateTime.split('T')[0]

          let x = new Date(inceptD)
          let y = new Date(today)

          let diff = y - x
          let daydiff = diff / (1000 * 60 * 60 * 24)
          obj.daysSinceInception = daydiff
          return obj
        }
        return null
      })

      action.value.map(function (obj) {
        if (obj.leverageFactor != null) {
          if (obj.leverageFactor === 1) {
            obj.productType = i18n.t('Unleveraged')
            obj.leverageFactor = i18n.t('Unleveraged')
          } else {
            obj.productType = i18n.t('ShortAndLeveraged')
            obj.leverageFactor = obj.leverageFactor + 'x'
          }
          return obj
        }
        return null
      })

      action.value.map(function (obj) {
        if (obj.Region != null) {
          const x = obj.Region.toString().split('|')
          obj.productRegion = x
          return obj
        }
        return null
      })
      //overide mstar
      action.value.map(function (obj) {
        if (obj.MorningStarRating != null) {
          if (obj.MorningStarRating === 1 || obj.MorningStarRating === 2) {
            obj.MorningStarRating = null
          }
          return obj
        }
        return null
      })

      let sortColumn = state.sortColumn
      const sortedDataOrig = action.value.sort((a, b) => a[state.sortColumn] - b[sortColumn])
      if (state.sortDirection === 'DESC') {
        sortedDataOrig.reverse()
      }
      return Object.assign({}, state, {
        allFunds: action.value,
        filteredFunds: sortedDataOrig,
        asOfDate: asOfDate,
        wtDivisionID: wtDivisionID,
        initialLoad: true
      })

    case actionTypes.FILTER_DATA:
      const filtered = getFilteredData(state, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true)
      return Object.assign({}, state, {
        filteredFunds: filtered
      })

    case actionTypes.SET_PRODUCTTYPE:
      const prodTypeFilter = action.value
      return Object.assign({}, state, {
        selectedProductTypeOptions: prodTypeFilter
      })

    case actionTypes.SET_USEOFINCOME:
      const useOfIncomeFilter = action.value
      return Object.assign({}, state, {
        selectedUseOfIncomeOptions: useOfIncomeFilter
      })

    case actionTypes.SET_MGTSTYLE:
      const mgtStyleFilter = action.value
      return Object.assign({}, state, {
        selectedMgtStyleOptions: mgtStyleFilter
      })

    case actionTypes.SET_TIER1CAT:
      const tier1Filter = action.value
      return Object.assign({}, state, {
        selectedTier1Options: tier1Filter
      })

    case actionTypes.SET_TIER2CAT:
      const tier2Filter = action.value
      return Object.assign({}, state, {
        selectedTier2Options: tier2Filter
      })

    case actionTypes.SET_TIER3CAT:
      const tier3Filter = action.value
      return Object.assign({}, state, {
        selectedTier3Options: tier3Filter
      })

    case actionTypes.SET_COUNTRYEXP:
      const countryFilter = action.value
      return Object.assign({}, state, {
        selectedCountryExpOptions: countryFilter
      })

    case actionTypes.SET_INCEPTION:
      const inceptionFilter = action.value
      return Object.assign({}, state, {
        selectedInceptionOptions: inceptionFilter
      })

    case actionTypes.SET_AUM:
      const aumFilter = action.value
      return Object.assign({}, state, {
        selectedAumOptions: aumFilter
      })

    case actionTypes.SET_YIELD:
      const yieldFilter = action.value
      return Object.assign({}, state, {
        selectedYieldOptions: yieldFilter
      })

    case actionTypes.SET_VOLUME:
      const volumeFilter = action.value
      return Object.assign({}, state, {
        selectedVolumeOptions: volumeFilter
      })

    case actionTypes.SET_EXPENSE:
      const expenseFilter = action.value
      return Object.assign({}, state, {
        selectedExpenseOptions: expenseFilter
      })

    case actionTypes.SET_MSTAR:
      const mstarFilter = action.value
      return Object.assign({}, state, {
        selectedMstarOptions: mstarFilter
      })

    case actionTypes.SET_PRODUCT_REGION:
      const productRegionFilter = action.value
      return Object.assign({}, state, {
        selectedProductRegionOptions: productRegionFilter
      })

    case actionTypes.SET_LEVERAGEDOPT:
      const leverageFilter = action.value
      return Object.assign({}, state, {
        selectedLeverageOptions: leverageFilter
      })

    case actionTypes.SET_STRUCTURE:
      const structureFilter = action.value
      return Object.assign({}, state, {
        selectedStructureOptions: structureFilter
      })

    case actionTypes.SET_ESG:
      const esgFilter = action.value
      return Object.assign({}, state, {
        selectedEsgOptions: esgFilter
      })

    case actionTypes.SET_SORT:
      const column = action.column
      let direction = 'ASC'
      if (column === '') {
        direction = 'ASC'
      } else if (column === state.sortColumn) {
        direction = state.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      }
      return Object.assign({}, state, {
        sortColumn: column,
        sortDirection: direction
      })

    case actionTypes.SET_SHOWLIST:
      const showDocuments = action.ticker
      return Object.assign({}, state, { showDocumentList: showDocuments })

    case actionTypes.SET_SHOWFLAG:
      const newTicker = action.ticker
      let toggleDocument = state.toggleDocument
      const oldTicker = state.oldTicker
      const showDocumentList = state.showDocumentList
      if (toggleDocument === true) {
        //same ticker
        if (newTicker === showDocumentList && oldTicker.length === 0) {
          //same ticker
        } else if (newTicker === showDocumentList && oldTicker.length > 0 && oldTicker === showDocumentList) {
          //same ticker
          toggleDocument = false
        } else if (newTicker !== oldTicker && oldTicker !== showDocumentList) {
          //same ticker
          //toggleDocument = true;
        }
      } else {
        if (newTicker === showDocumentList && oldTicker.length > 0) {
          //same ticker
          toggleDocument = true
        }
      }

      return Object.assign({}, state, {
        toggleDocument: toggleDocument,
        oldTicker: showDocumentList
      })

    case actionTypes.SORT_DATA_DETAILS:
      const filterToSort = state.filteredFunds
      sortColumn = state.sortColumn
      const sortDirection = state.sortDirection
      let sortedData = []
      if (sortColumn === '') {
        sortColumn = 'displayName'
      }
      if (sortColumn === 'AUM') {
        sortColumn = 'AUMusd'
      }
      if (sortColumn === 'NAV') {
        sortColumn = 'NAVusd'
      }
      if (sortColumn === 'YIELD') {
        sortColumn = 'TTMYieldOrdIncome'
      }

      sortedData = filterToSort.sort(function (a, b) {
        if (a[sortColumn] === b[sortColumn]) {
          return 0
        }
        if (a[sortColumn] === null) {
          return -1
        } else if (b[sortColumn] === null) {
          return 1
        } else if (typeof a[sortColumn] === 'string') {
          return a[sortColumn].localeCompare(b[sortColumn])
        } else if (typeof a[sortColumn] === 'number' || typeof a[sortColumn] === 'boolean') {
          if (a[sortColumn] < b[sortColumn]) {
            return -1
          }
          if (a[sortColumn] > b[sortColumn]) {
            return 1
          }
        }
        return 0
      })

      if (state.sortDirection === 'DESC') {
        sortedData.reverse()
      }
      return Object.assign({}, state, {
        sortedEntities: sortedData,
        sortDirection: sortDirection
      })

    case actionTypes.SET_FILTER_WORD:
      const searchWord = action.value

      const filteredFunds = state.allFunds

      let filteredWord = []
      let filteredDesc = []
      let filteredWKN = []
      let filteredISIN = []
      let filteredTier3 = []
      let filteredTier2 = []
      let filteredTier1 = []
      let filteredLeverage = []
      let filteredMgtStyle = []
      let filteredProductType = []
      let filteredResponsibleInvesting = []
      filteredWord = filteredFunds.filter(item => JSON.stringify(item.name).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredTier1 = filteredFunds.filter(item => JSON.stringify(item.fundCategoryTier3).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredTier2 = filteredFunds.filter(item => JSON.stringify(item.fundCategoryTier2).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredTier3 = filteredFunds.filter(item => JSON.stringify(item.fundCategoryTier1).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredLeverage = filteredFunds.filter(item => JSON.stringify(item.leverageFactor).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredDesc = filteredFunds.filter(item => JSON.stringify(item.bloombergTicker).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredWKN = filteredFunds.filter(item => JSON.stringify(item.WKN).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredISIN = filteredFunds.filter(item => JSON.stringify(item.ISIN).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredMgtStyle = filteredFunds.filter(item => JSON.stringify(item.MgtStyle).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredProductType = filteredFunds.filter(item => JSON.stringify(item.productType).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      filteredResponsibleInvesting = filteredFunds.filter(item => JSON.stringify(item.esgTagArray).toLowerCase().indexOf(searchWord.toLowerCase()) !== -1)
      let combo = filteredWord.concat(filteredDesc).concat(filteredWKN).concat(filteredISIN).concat(filteredTier3).concat(filteredTier2).concat(filteredTier1).concat(filteredLeverage).concat(filteredMgtStyle).concat(filteredProductType).concat(filteredResponsibleInvesting)

      const set = new Set(combo)
      combo = Array.from(set)
      return Object.assign({}, state, {
        filteredFunds: combo,
        searchValue: searchWord,
        searchBoxText: searchWord
      })

    case actionTypes.SET_ACTIVE_PANE:
      const active_pane = action.value
      return Object.assign({}, state, {
        activePane: active_pane
      })
    case actionTypes.RESET_LOAD_STATUS:
      const reloadStatus = action.value
      return Object.assign({}, state, {
        initialLoad: reloadStatus
      })

    default:
      return state
  }
}

function getFilteredData(state, productType, style, tier1, tier2, tier3, country, productRegion, leverage, useOfIncome, esg, inception, aum, mstar, ttmyield, volume, expense) {
  let filtered = state.allFunds
  if (productType && state.selectedProductTypeOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      return state.selectedProductTypeOptions.includes(fund.productType)
    })
  }
  if (style && state.selectedMgtStyleOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      return state.selectedMgtStyleOptions.includes(fund.MgtStyle)
    })
  }
  if (tier1 && state.selectedTier1Options.length > 0) {
    filtered = filtered.filter(function (fund) {
      return state.selectedTier1Options.includes(fund.fundCategoryTier1)
    })
  }
  if (tier2 && state.selectedTier2Options.length > 0) {
    filtered = filtered.filter(function (fund) {
      return state.selectedTier2Options.includes(fund.fundCategoryTier2)
    })
  }
  if (tier3 && state.selectedTier3Options.length > 0) {
    filtered = filtered.filter(function (fund) {
      return state.selectedTier3Options.includes(fund.fundCategoryTier3)
    })
  }
  if (country && state.selectedCountryExpOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      const inCommon = [...new Set(state.selectedCountryExpOptions)].filter(x => new Set(fund.exposures).has(x))
      return inCommon.length > 0 ? true : false
    })
  }
  if (productRegion && state.selectedProductRegionOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      const inCommon = [...new Set(state.selectedProductRegionOptions)].filter(x => new Set(fund.productRegion).has(x))
      return inCommon.length > 0 ? true : false
    })
  }
  if (leverage && state.selectedLeverageOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      return state.selectedLeverageOptions.includes(fund.leverageFactor)
    })
  }
  if (useOfIncome && state.selectedUseOfIncomeOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      return state.selectedUseOfIncomeOptions.includes(fund.useOfIncome)
    })
  }
  if (esg && state.selectedEsgOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      const inCommon = [...new Set(state.selectedEsgOptions)].filter(x => new Set(fund.esgTag).has(x))
      return inCommon.length > 0 ? true : false
    })
  }
  if (inception && state.selectedInceptionOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      if (state.selectedInceptionOptions.includes('All Inception Dates')) {
        return fund
      }
      if (state.selectedInceptionOptions.includes('Over 1 Year')) {
        return fund.daysSinceInception >= 365
      }
      if (state.selectedInceptionOptions.includes('Over 3 Year')) {
        return fund.daysSinceInception >= 1095
      }
      if (state.selectedInceptionOptions.includes('Over 5 Year')) {
        return fund.daysSinceInception >= 1825
      }
      if (state.selectedInceptionOptions.includes('Over 10 Year')) {
        return fund.daysSinceInception >= 3650
      }
      return fund.daysSinceInception
    })
  }

  if (aum && state.selectedAumOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      if (state.selectedAumOptions.includes('All AUM')) {
        return fund
      }
      if (state.selectedAumOptions.includes('50M')) {
        return fund.AUM >= 50000000
      }

      if (state.selectedAumOptions.includes('100M')) {
        return fund.AUM >= 100000000
      }

      if (state.selectedAumOptions.includes('500M')) {
        return fund.AUM >= 500000000
      }
      if (state.selectedAumOptions.includes('1B')) {
        return fund.AUM >= 1000000000
      }
      return fund.AUM
    })
  }

  if (ttmyield && state.selectedYieldOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      if (state.selectedYieldOptions.includes('All Yields')) {
        return fund.TTMYieldOrdIncome
      }
      if (state.selectedYieldOptions.includes('Over 1%')) {
        return fund.TTMYieldOrdIncome > 0.01
      }
      if (state.selectedYieldOptions.includes('Over 2%')) {
        return fund.TTMYieldOrdIncome > 0.02
      }
      if (state.selectedYieldOptions.includes('Over 3%')) {
        return fund.TTMYieldOrdIncome > 0.03
      }
      if (state.selectedYieldOptions.includes('Over 4%')) {
        return fund.TTMYieldOrdIncome > 0.04
      }
      if (state.selectedYieldOptions.includes('Over 5%')) {
        return fund.TTMYieldOrdIncome > 0.05
      }
      return fund.TTMYieldOrdIncome
    })
  }

  if (mstar && state.selectedMstarOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      if (state.selectedMstarOptions.includes('All MorningStar Ratings')) {
        return fund.MorningStarRating
      }
      if (state.selectedMstarOptions.includes('3 Stars')) {
        return fund.MorningStarRating >= 3
      }
      if (state.selectedMstarOptions.includes('4 Stars')) {
        return fund.MorningStarRating >= 4
      }
      if (state.selectedMstarOptions.includes('5 Stars')) {
        return fund.MorningStarRating >= 5
      }
      return fund.MorningStarRating
    })
  }
  if (volume && state.selectedVolumeOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      if (state.selectedVolumeOptions.includes('All Volume')) {
        return fund.volume
      }
      if (state.selectedVolumeOptions.includes('Over 10,000')) {
        return fund.volume > 10000
      }
      if (state.selectedVolumeOptions.includes('Over 30,000')) {
        return fund.volume > 30000
      }
      if (state.selectedVolumeOptions.includes('Over 50,000')) {
        return fund.volume > 50000
      }
      if (state.selectedVolumeOptions.includes('Over 100,000')) {
        return fund.volume > 100000
      }
      if (state.selectedVolumeOptions.includes('Over 300,000')) {
        return fund.volume > 300000
      }
      return fund.volume
    })
  }

  if (expense && state.selectedExpenseOptions.length > 0) {
    filtered = filtered.filter(function (fund) {
      if (state.selectedExpenseOptions.includes('All Expense Ratios')) {
        return fund.expenseRatio
      }
      if (state.selectedExpenseOptions.includes('Less than 10 bps')) {
        return fund.expenseRatio < 0.001
      }
      if (state.selectedExpenseOptions.includes('Less than 20 bps')) {
        return fund.expenseRatio < 0.002
      }
      if (state.selectedExpenseOptions.includes('Less than 30 bps')) {
        return fund.expenseRatio < 0.003
      }
      if (state.selectedExpenseOptions.includes('Less than 40 bps')) {
        return fund.expenseRatio < 0.004
      }
      if (state.selectedExpenseOptions.includes('Less than 50 bps')) {
        return fund.expenseRatio < 0.005
      }
      return fund.expenseRatio
    })
  }

  return filtered
}

// READS

export const getProfileData = state => state.data.filteredFunds

export const getProductTypeOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true, //yield
    true, //vol
    true //exp
  )
  return [
    ...new Set(
      filteredFunds
        .map(i => i.productType)
        .sort()
        .reverse()
    )
  ]
}

export const getMgtStyleOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true, //yield
    true, //vol
    true //exp
  )
  return [...new Set(filteredFunds.map(i => i.MgtStyle).sort())]
}

export const getTier1CatOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true, //yield
    true, //vol
    true //exp
  )
  return [...new Set(filteredFunds.map(i => i.fundCategoryTier1).sort())]
}

export const getTier2CatOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true, //yield
    true, //vol
    true //exp
  )
  return [...new Set(filteredFunds.map(i => i.fundCategoryTier2).sort())]
}

export const getTier3CatOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true //yield
  )
  return [...new Set(filteredFunds.map(i => i.fundCategoryTier3).sort())]
}

export const getCountryExpOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true, //yield
    true, //vol
    true //exp
  )
  const x = filteredFunds.reduce((acc, fund) => acc.concat([fund.exposures]), [])
  const flat = x.reduce((all, fund) => {
    return all.concat(fund)
  }, [])
  const values = [...new Set(flat.sort())]
  return values.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}

export const getProductRegionOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true, //yield
    true, //vol
    true //exp
  )
  const x = filteredFunds.reduce((acc, fund) => acc.concat([fund.productRegion]), [])
  const flat = x.reduce((all, fund) => {
    return all.concat(fund)
  }, [])
  const values = [...new Set(flat.sort())]
  return values.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}

export const getLeverageOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true, //yield
    true, //vol
    true //exp
  )
  const values = [...new Set(filteredFunds.map(i => i.leverageFactor))]
  const index = values.indexOf('Unleveraged')
  if (index > -1) {
    values.splice(index, 1)
  }
  values.sort((a, b) => {
    return a.slice(0, -1) - b.slice(0, -1)
  })
  if (index > -1) {
    values.unshift('Unleveraged')
  }
  return values
}

export const getUseOfIncomeOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true, //yield
    true, //vol
    true //exp
  )
  return [
    ...new Set(
      filteredFunds
        .map(i => i.useOfIncome)
        .sort()
        .reverse()
    )
  ]
}

export const getEsgOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true, //yield
    true, //vol
    true //exp
  )
  const x = filteredFunds.reduce((acc, fund) => acc.concat([fund.esgTag]), [])
  const flat = x.reduce((all, fund) => {
    return all.concat(fund)
  }, [])
  const values = [...new Set(flat.sort())]
  return values.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}

export const getInceptionOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true, //productType,
    true, //style,
    true, //tier1,
    true, //tier2,
    true, //tier3,
    true, //country,
    true, //productRegion,
    true, //leverage,
    true, //useOfIncome,
    true, //esg,
    false, // inception,
    true, //aum
    true, //mstar
    true, //yield
    true, //vol
    true //exp
  )
  const x = filteredFunds.reduce((acc, fund) => acc.concat([fund.inceptionDt]), [])
  const flat = x.reduce((all, fund) => {
    return all.concat(fund)
  }, [])
  // const values = [...new Set(flat.sort())];

  let values = ['All Inception Dates', 'Over 1 Year', 'Over 3 Years', 'Over 5 Years', 'Over 10 Years']
  return values.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}

export const getAumOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true, //productType,
    true, //style,
    true, //tier1,
    true, //tier2,
    true, //tier3,
    true, //country,
    true, //productRegion,
    true, //leverage,
    true, //useOfIncome,
    true, //esg,
    true, // inception,
    false, //aum
    true, //mstar
    true, //yield
    true, //vol
    true //exp
  )
  const x = filteredFunds.reduce((acc, fund) => acc.concat([fund.AUM]), [])
  const flat = x.reduce((all, fund) => {
    return all.concat(fund)
  }, [])
  let values = ['All AUM', 'Over 50M', 'Over 100M', 'Over 500M', 'Over 1B']
  return values.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}

export const getMstarOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true, //productType,
    true, //style,
    true, //tier1,
    true, //tier2,
    true, //tier3,
    true, //country,
    true, //productRegion,
    true, //leverage,
    true, //useOfIncome,
    true, //esg,
    true, // inception,
    true, //aum
    false, //mstar
    true, // ttmyield
    true, //vol
    true //exp
  )
  const x = filteredFunds.reduce((acc, fund) => acc.concat([fund.MorningStarRating]), [])
  const flat = x.reduce((all, fund) => {
    return all.concat(fund)
  }, [])

  let values = ['All MorningStar Ratings', '3 Stars', '4 Stars', '5 Stars']
  return values.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}
export const getYieldOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true, //productType,
    true, //style,
    true, //tier1,
    true, //tier2,
    true, //tier3,
    true, //country,
    true, //productRegion,
    true, //leverage,
    true, //useOfIncome,
    true, //esg,
    true, // inception,
    true, //aum
    true, //mstar
    false, // ttmyield
    true, //vol
    true //exp
  )
  const x = filteredFunds.reduce((acc, fund) => acc.concat([fund.TTMYieldOrdIncome]), [])
  const flat = x.reduce((all, fund) => {
    return all.concat(fund)
  }, [])
  //const values = [...new Set(flat.sort())];

  let yieldValues = ['All Yields', 'Over 1%', 'Over 2%', 'Over 3%', 'Over 4%', 'Over 5%']
  return yieldValues.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}
export const getVolumeOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true, //productType,
    true, //style,
    true, //tier1,
    true, //tier2,
    true, //tier3,
    true, //country,
    true, //productRegion,
    true, //leverage,
    true, //useOfIncome,
    true, //esg,
    true, // inception,
    true, //aum
    true, //mstar
    true, // ttmyield
    false, //vol
    true //exp
  )

  const x = filteredFunds.reduce((acc, fund) => acc.concat([fund.volume]), [])
  const flat = x.reduce((all, fund) => {
    return all.concat(fund)
  }, [])

  //const values = [...new Set(flat.sort())];
  let volumeValues = ['All Volume', 'Over 10,000', 'Over 30,000', 'Over 50,000', 'Over 100,000', 'Over 300,000']
  return volumeValues.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}
export const getExpenseOption = state => {
  const filteredFunds = getFilteredData(
    state.data,
    true, //productType,
    true, //style,
    true, //tier1,
    true, //tier2,
    true, //tier3,
    true, //country,
    true, //productRegion,
    true, //leverage,
    true, //useOfIncome,
    true, //esg,
    true, // inception,
    true, //aum
    true, //mstar
    true, // ttmyield
    true, //vol
    false //exp
  )
  const x = filteredFunds.reduce((acc, fund) => acc.concat([fund.expenseRatio]), [])
  const flat = x.reduce((all, fund) => {
    return all.concat(fund)
  }, [])

  // const values = [...new Set(flat.sort())];

  let expenseValues = ['All Expense Ratios', 'Less than 10 bps', 'Less than 20 bps', 'Less than 30 bps', 'Less than 40 bps', 'Less than 50 bps']
  return expenseValues.filter(function (val) {
    return val !== undefined && val !== 'Unknown'
  })
}

export const getSelectedProductTypeOption = state => state.data.selectedProductTypeOptions
export const getSelectedUseOfIncomeOption = state => state.data.selectedUseOfIncomeOptions
export const getSelectedMgtStyleOption = state => state.data.selectedMgtStyleOptions
export const getSelectedTier1CatOption = state => state.data.selectedTier1Options
export const getSelectedTier2CatOption = state => state.data.selectedTier2Options
export const getSelectedTier3CatOption = state => state.data.selectedTier3Options
export const getSelectedLeverageOption = state => state.data.selectedLeverageOptions
export const getSelectedCurrenciesOption = state => state.data.selectedCurrenciesOptions
export const getSelectedCountryExpOption = state => state.data.selectedCountryExpOptions
export const getSelectedProductRegionOption = state => state.data.selectedProductRegionOptions
export const getSelectedEsgOption = state => state.data.selectedEsgOptions
export const getSelectedInceptionOption = state => state.data.selectedInceptionOptions
export const getSelectedAumOption = state => state.data.selectedAumOptions
export const getSelectedYieldOption = state => state.data.selectedYieldOptions
export const getSelectedMstarOption = state => state.data.selectedMstarOptions
export const getSelectedExpenseOption = state => state.data.selectedExpenseOptions
export const getSelectedVolumeOption = state => state.data.selectedVolumeOptions
export const getSortDirection = state => state.data.sortDirection
export const getSortColumn = state => state.data.sortColumn
export const getToggleDocument = state => state.data.toggleDocument
export const getDocumentForm = state => state.data.toggleDocument
export const getShowDocList = state => state.data.showDocumentList
export const getSearchBoxText = state => state.data.searchBoxText
export const getAsOfDate = state => state.data.asOfDate
export const getInitialLoad = state => state.data.initialLoad
export const getActivePane = state => state.data.activePane
export default data



// WEBPACK FOOTER //
// ./src/reducers/data.js